import { useProfile } from "@/context/useProfileProps";
import { OTPInput } from "@monsterindia/global-ui-components";
import React, { useEffect, useImperativeHandle, useState } from "react";

import {
  useSendEmailOTP,
  useVerifyEmailOTP,
} from "@/components/profile/contactCard/query";
import { EmailOTPProps } from "@/components/profile/contactCard/types";

const EmailOTP = ({
  closeModal,
  email,
  otpId,
  otpRef,
  setLoading,
}: EmailOTPProps) => {
  const {
    translation: { contactCard, errorMessages },
    showToast,
    handleEventTracking,
  } = useProfile();
  const [emailOTPId, setEmailOTPId] = useState(otpId);
  const [otpValue, setOTPValue] = useState("");
  const [otpError, setOtpError] = useState<string>("");

  const { mutate: sendEmailOTP } = useSendEmailOTP();
  const { mutate: verifyEmailOTP } = useVerifyEmailOTP();

  const handleResendClick = async () => {
    // api call to resend otp
    sendEmailOTPHandler(email);
    setOTPValue("");
    setOtpError("");
  };

  const otpUpdateHandler = (newOTP: string) => {
    setOTPValue(newOTP);
    setOtpError("");
  };

  const sendEmailOTPHandler = async (email: string) => {
    setLoading(true);
    const apiData = {
      email: email,
    };

    sendEmailOTP(apiData, {
      onSuccess: (data) => {
        setEmailOTPId(data?.id);
        setLoading(false);
        showToast({
          show: true,
          type: "success",
          message: "OTP sent successfully",
        });
      },
      onError: (err) => {
        setLoading(false);
        showToast({
          show: true,
          type: "error",
          message:
            err instanceof Error
              ? err.message
              : errorMessages.somethingWentWrong,
        });
      },
    });
  };

  const verifyEmailOTPHandler = async (
    otpValue: string,
    otpId: string,
    email: string,
  ) => {
    setLoading(true);
    const apiData = {
      otp: otpValue,
      otpId: otpId,
      email: { email },
    };
    setOtpError("");
    verifyEmailOTP(apiData, {
      onSuccess: (data) => {
        setLoading(false);
        showToast({
          show: true,
          type: "success",
          message: "OTP verified successfully",
        });
        let urlParams = new URLSearchParams(window.location.search);
        const isApp = urlParams.get("app") === "true";
        handleEventTracking({
          eventType: "eventPush",
          eventName: "ProfilePage_Section_Verified",
          eventProps: {
            Contact_Info_Verified: `email = ${email}`,
            Source: isApp ? "app" : "web",
          },
        });
        closeModal("save");
      },
      onError: (err) => {
        setLoading(false);
        setOtpError(
          err instanceof Error ? err.message : errorMessages.somethingWentWrong,
        );
        // showToast({
        //   show: true,
        //   type: "error",
        //   message:
        //     err instanceof Error
        //       ? err.message
        //       : errorMessages.somethingWentWrong,
        // });
      },
    });
  };

  useImperativeHandle(otpRef, () => ({
    verifyOTPHandler: () => verifyEmailOTPHandler(otpValue, emailOTPId, email),
  }));

  useEffect(() => {
    setEmailOTPId(otpId);
  }, [otpId]);

  return (
    <div className="flex w-full flex-col gap-4 md:max-h-[370px] md:min-h-[40vh]">
      <div className="flex flex-col items-start gap-2 text-sm">
        <p className="text-grey-3 text-sm">
          {contactCard.sendVerificationCodeHeadingForEmail}
          <br />
        </p>
        <p className="text-sm text-blue-600">{email}</p>
      </div>

      <OTPInput
        otpValue={otpValue}
        errorMessage={otpError}
        otpUpdateHandler={otpUpdateHandler}
        resendClickHandler={handleResendClick}
        resendTime={60}
      />
    </div>
  );
};

export default EmailOTP;
